import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import _ from 'lodash';

import {
	vectorLayerDefaultFeatureStyle as defaultStyle,
	vectorLayerHighlightedFeatureStyle as highlightedFeatureStyle
} from "../../constants";


class VectorLayer extends React.PureComponent {
	// todo handle custom styles
	static propTypes = {
		data: PropTypes.object,
		group: PropTypes.object,
		zIndex: PropTypes.number
	};

	constructor(props) {
		super(props);

		this.layer = L.geoJSON(props.data.options.features, {
			style: this.getLayerStyle.bind(this),
			onEachFeature: this.onEachFeature.bind(this),
			zIndex: this.props.zIndex
		});

		this.state = {
			selectedFeature: props.selectedFeature
		};

		props.group.addLayer(this.layer);
	}

	componentDidMount() {
		this.checkSelected();
	}

	componentDidUpdate() {
		this.checkSelected();
	}


	checkSelected() {
		let keyColumn = this.props.data.options.keyProperty;
		if (keyColumn) {
			let self = this;
			this.layer.eachLayer(function (feature) {
				let key = feature.feature.properties[keyColumn];
				if (key === self.state.selectedFeature) {
					self.highlightFeature(feature);
				} else {
					self.layer.resetStyle(feature);
				}
			});
		}
	}

	// TODO quick solution for choropleths. Find out choropleths in general.
	getLayerStyle(feature) {
		const propStyle = this.props.data && this.props.data.options && this.props.data.options.style;
		let fillColor = defaultStyle.fillColor;
		if (propStyle && propStyle.fillColor) {
			if (typeof propStyle.fillColor === 'function') {
				fillColor = propStyle.fillColor(feature.properties[this.props.data.options.valueProperty]);
			} else {
				fillColor = propStyle.fillColor;
			}
		}

		return {
			opacity: (this.props.data && this.props.data.opacity) || 1,
			fillOpacity: (propStyle && propStyle.fillOpacity) || defaultStyle.fillOpacity,
			fillColor,
			weight: (propStyle && propStyle.strokeWidth) || defaultStyle.strokeWidth,
			color: (propStyle && propStyle.strokeColor) || defaultStyle.strokeColor
		};
	}

	highlightFeature(feature) {
		feature.setStyle({
			color: highlightedFeatureStyle.strokeColor || feature.options.color,
			fillOpacity: highlightedFeatureStyle.fillOpacity  || feature.options.fillOpacity,
			fillColor: highlightedFeatureStyle.fillColor || feature.options.fillColor,
			weight: highlightedFeatureStyle.strokeWidth || feature.options.weight
		});

		if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
			feature.bringToFront();
		}
	}

	onEachFeature(feature, layer) {
		layer.on({
			mousemove: (e) => {
				this.highlightFeature(e.target);
			},
			mouseout: (e) => {
				let key = null;
				let keyColumn = this.props.data.options.keyProperty;
				if (keyColumn) {
					key = e.target.feature.properties[keyColumn];
				}

				if (key !== this.state.selectedFeature) {
					this.layer.resetStyle(e.target);
				}
			},
			click: (e) => {
				if (this.props.onFeatureClick) {
					this.highlightFeature(e.target);

					if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
						layer.bringToFront();
					}

					let keyColumn = this.props.data.options.keyProperty;
					if (keyColumn) {
						this.props.onFeatureClick(e.target.feature.properties[keyColumn]);
						this.setState({selectedFeature: e.target.feature.properties[keyColumn]});
					}
				}
			}
		});
	}

	render() {
		return null;
	}
}

export default VectorLayer;
